import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { fg } from '@confluence/feature-gating';
import { useIsNewUser } from '@confluence/targeting/entry-points/useIsNewUser.ts';

/**
 * Hook to determine eligibility for auto-opening notifications experiment
 * Checks:
 * 1. User is logged in
 * 2. User is licensed
 * 3. User is new (less than 28 days)
 *
 * Returns false while user is not logged in or unlicensed
 */
export const useAutoOpenNotificationsEligibility = (): boolean => {
	const { isLoggedIn, accessStatus } = useSessionData();
	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	// Make new user call only when the killswitch is enabled
	const { isNewUser } = useIsNewUser(
		{ activeDaysThreshold: 28 },
		!fg('cc_activation_auto_open_notifs_gate'),
	);

	return isLoggedIn && isLicensed && Boolean(isNewUser);
};
